export const DESKTOP_BREAKPOINT_WIDTH = 960
